var table_viewer_default = {
  "viewMode": "ml3rL",
  "editMode": "ffZLI",
  "container": "k-RPJ",
  "cell": "iM9uK"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
